import { observer } from 'mobx-react-lite';
import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom';


const Documents: FC = () => {

    const navigate = useNavigate()

    return (
        <div className='row pt-4 justify-content-center m-3'>
            <div className='col-md-4 text-center' onClick={() => navigate('/documents/1/')} style={{ cursor: 'pointer' }}>
                <img src="/images/international.jpg" alt="" className="img_wrap2"/>
                <p className='text-center fw-bold text-uppercase'>Международные</p>
            </div>
            <div className='col-md-4 text-center' onClick={() => navigate('/documents/2/')} style={{ cursor: 'pointer' }}>
                <img src="/images/federal.jpg" alt="" className="img_wrap2"/>
                <p className='text-center fw-bold text-uppercase'>Федеральные</p>
            </div>
            <div className='col-md-4 text-center' onClick={() => navigate('/documents/3/')} style={{ cursor: 'pointer' }}>
                <img src="/images/regional.jpg" alt="" className="img_wrap2"/>
                <p className='text-center fw-bold text-uppercase'>Региональные</p>
            </div>

            <div className='col-md-4 text-center' onClick={() => navigate('/documents/5/')} style={{ cursor: 'pointer' }}>
                <img src="/images/other_docs.webp" alt="" className="img_wrap2"/>
                <p className='text-center fw-bold text-uppercase'>Республиканские методические разработки</p>
            </div>
        </div>
    );
};

export default observer(Documents);